export const FETCH_CONTENT_DATA_INIT = 'FETCH_CONTENT_DATA_INIT';
export const FETCH_CONTENT_DATA_SUCCESS = 'FETCH_CONTENT_DATA_SUCCESS';
export const FETCH_CONTENT_DATA_ERROR = 'FETCH_CONTENT_DATA_ERROR';
